import focus from './lib/focus-element';
import {delegate} from './lib/events';
import ready from "./lib/ready";

ready().then(function () {
    document.addEventListener('click', delegate('a[href="#content"]', function (e) {
        e.preventDefault();
        focus.call(document.getElementById('content'), true);
    }));
});